import { Tooltip } from "@heroui/react";
import {
  LucideAlertOctagon,
  LucideAlertTriangle,
  LucideCheckCircle,
  LucideClock,
} from "lucide-react";
import {
  FactoryMakeAssistantToolUI,
  ToolArguments,
  ToolErrorResponse,
} from "../../../features/Prompt/FactoryMakeAssistantToolUI";

const ToolParameters = ({
  args,
  error,
}: {
  args: ToolArguments;
  error?: string;
}) => {
  return (
    <div className="p-2 max-w-sm">
      {error && (
        <div className="mb-2">
          <div className="font-bold text-xs mb-1 text-red-600">Erreur:</div>
          <div className="text-xs text-red-600 p-2 bg-red-50 rounded">
            {error}
          </div>
        </div>
      )}

      <pre className="text-xs bg-gray-100 p-2 rounded overflow-auto max-h-[150px]">
        {JSON.stringify(args, null, 2)}
      </pre>
    </div>
  );
};

export const ErrorComponent = FactoryMakeAssistantToolUI({
  toolName: "ErrorComponent",
  ErrorCustomComponent: ({ args, toolName, error }) => {
    return (
      <Tooltip
        content={<ToolParameters args={args} error={error} />}
        placement="top"
      >
        <div className="cursor-pointer inline-flex items-center justify-center h-7 px-2 m-1 rounded-md bg-yellow-100 border border-yellow-300 text-yellow-800 text-xs whitespace-nowrap">
          <LucideAlertTriangle className="h-3 w-3 mr-1" />
          <span>{toolName}</span>
        </div>
      </Tooltip>
    );
  },
});

export const CrashComponent = FactoryMakeAssistantToolUI({
  toolName: "CrashComponent",
  ErrorCustomComponent: ({ args, toolName, error }) => {
    return (
      <Tooltip
        content={<ToolParameters args={args} error={error} />}
        placement="top"
      >
        <div className="cursor-pointer inline-flex items-center justify-center h-7 px-2 m-1 rounded-md bg-red-100 border border-red-300 text-red-800 text-xs whitespace-nowrap">
          <LucideAlertOctagon className="h-3 w-3 mr-1" />
          <span>{toolName}</span>
        </div>
      </Tooltip>
    );
  },
});

export const InfoToolComponent = FactoryMakeAssistantToolUI({
  toolName: "InfoToolComponent",
  SuccessComponent: ({ args, toolName }) => {
    return (
      <Tooltip content={<ToolParameters args={args} />} placement="top">
        <div className="cursor-pointer inline-flex items-center justify-center h-7 px-2 m-1 rounded-md bg-white border border-gray-200 text-gray-800 text-xs whitespace-nowrap">
          <LucideCheckCircle className="h-3 w-3 mr-1 text-green-600" />
          <span>{toolName}</span>
        </div>
      </Tooltip>
    );
  },
  LoadingComponent: ({ toolName }) => {
    return (
      <div className="cursor-pointer inline-flex items-center justify-center h-7 px-2 m-1 rounded-md bg-white border border-gray-200 text-gray-800 text-xs whitespace-nowrap">
        <LucideClock className="h-3 w-3 mr-1" />
        <span>{toolName}</span>
      </div>
    );
  },
});

export const SimulateDelayToolComponent = FactoryMakeAssistantToolUI({
  toolName: "SimulateDelayToolComponent",
  SuccessComponent: ({ args, toolName }) => {
    return (
      <Tooltip content={<ToolParameters args={args} />} placement="top">
        <div className="cursor-pointer inline-flex items-center justify-center h-7 px-2 m-1 rounded-md bg-white border border-gray-200 text-gray-800 text-xs whitespace-nowrap">
          <LucideCheckCircle className="h-3 w-3 mr-1" />
          <span>{toolName}</span>
        </div>
      </Tooltip>
    );
  },
  LoadingComponent: ({ toolName }) => {
    return (
      <div className="cursor-pointer inline-flex items-center justify-center h-7 px-2 m-1 rounded-md bg-white border border-gray-200 text-gray-800 text-xs whitespace-nowrap">
        <LucideClock className="h-3 w-3 mr-1" />
        <span>{toolName}</span>
      </div>
    );
  },
});

export const ErrorCustomComponent = FactoryMakeAssistantToolUI<
  ToolArguments,
  ToolErrorResponse,
  {
    time_error: string;
  }
>({
  toolName: "ErrorCustomComponent",
  ErrorCustomComponent: ({ toolName }) => {
    return (
      <div className="cursor-pointer inline-flex items-center justify-center h-7 px-2 m-1 rounded-md bg-white border border-gray-200 text-gray-800 text-xs whitespace-nowrap">
        <LucideAlertTriangle className="h-3 w-3 mr-1" />
        <span>Custom Error: {toolName}</span>
      </div>
    );
  },
});
